define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.InputField = void 0;
    class InputField extends Autodesk.Viewing.UI.Control {
        constructor(id, title) {
            super(id, {});
            // @ts-ignore
            const _document = this.getDocument();
            // @ts-ignore
            const container = (this.container = _document.createElement('div'));
            container.id = id;
            this.addClass('adsk-control');
            this.addClass('adsk-input');
            this._input = _document.createElement('input');
            this._input.classList.add('docking-panel-delimiter-shadow');
            this._input.type = 'text';
            this._input.placeholder = title;
            container.appendChild(this._input);
        }
        getValue() {
            return this._input.value;
        }
        clearValue() {
            this._input.value = '';
        }
    }
    exports.InputField = InputField;
});
//# sourceMappingURL=InputField.js.map